import React, {Fragment} from 'react'

const Categories = (props) => {
    return (
        <Fragment>
            <div className="maximumSizeHandler">
                <div className="contentTitle">
                    <span className=" font-size_24 boldFont middleContext">دسته بندی ها</span>
                </div>
            </div>
            <span className="lineSeparator"></span>
            <div className="addCategoryContainer organizer">

                <div className="maximumSizeHandler">
                    <div className="categoryTable">

                        <div className="tableContainer relative">
                            <div className="tableStructure">
                                <div className="headerLine"></div>
                            </div>
                            <div className="tableContent">
                                <div className="tableItem">
                                    <div className="tableColumnItem">
                                        عنوان دسته بندی
                                    </div>
                                    <div className="tableColumnItem">فرهنگی
                                    </div>
                                    <div className="tableColumnItem">
                                        ادبی
                                    </div>
                                    <div className="tableColumnItem">
                                        هنری
                                    </div>
                                </div>
                                <div className="tableItem">
                                    <div className="tableColumnItem">
                                        توضیحات
                                    </div>
                                    <div className="tableColumnItem">لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از
                                        صنعت چاپ و
                                        با استفاده از طراحان گرافیک است.
                                    </div>
                                    <div className="tableColumnItem">لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از
                                        صنعت چاپ و
                                        با استفاده از طراحان گرافیک است.
                                    </div>
                                    <div className="tableColumnItem">لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از
                                        صنعت چاپ و
                                        با استفاده از طراحان گرافیک است.
                                    </div>
                                </div>

                                <div className="tableItem textInLeft">
                                    <div className="tableColumnItem emptyCell">
                                        null
                                    </div>
                                    <div className="tableColumnItem">
                                        <span className="icon icon-edit"></span>
                                        <span className="icon icon-eraser"></span>
                                    </div>
                                    <div className="tableColumnItem">
                                        <span className="icon icon-edit"></span>
                                        <span className="icon icon-eraser"></span>
                                    </div>
                                    <div className="tableColumnItem">
                                        <span className="icon icon-edit"></span>
                                        <span className="icon icon-eraser"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="addCategoryForm">

                        <div className="formContainer">
                            <div className="inputContainer">
                                <label>عنوان کتاب</label>
                                <input className="standardInput" />
                            </div>
                        </div>
                        <div className="inputContainer description">
                            <label>توضیحات</label>
                            <textarea className="standardInput"></textarea>
                        </div>

                        <div className="normalButton outlineMode greenButton"><span
                            className="icon icon-add font-size_14 middleContext"></span> اضافه به لیست
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Categories;
